import React from 'react';

export const PersonalTabSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col-reverse lg:grid lg:grid-cols-3 gap-6 mb-16">
      {/* Main content - takes 2 columns on desktop */}
      <div className="lg:col-span-2">
        <div className="bg-white rounded-xl p-6 border border-[#E4E8EA] animate-pulse">
          <div className="h-6 w-56 bg-gray-200 rounded mb-6"></div>

          {/* Two column grid - single column on mobile */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Student Details Column */}
            <div>
              <div className="h-5 w-32 bg-gray-200 rounded mb-2"></div>
              <div className="space-y-4">
                {[...Array(6)].map((_, i) => (
                  <div key={i} className="space-y-1">
                    <div className="h-4 w-24 bg-gray-200 rounded"></div>
                    <div className="h-5 w-48 bg-gray-100 rounded"></div>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact Information Column */}
            <div>
              <div className="h-5 w-40 bg-gray-200 rounded mb-2"></div>
              <div className="space-y-4">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="space-y-1">
                    <div className="h-4 w-28 bg-gray-200 rounded"></div>
                    <div className="h-5 w-full bg-gray-100 rounded"></div>
                    {i === 2 && (
                      <div className="h-5 w-3/4 bg-gray-100 rounded mt-1"></div>
                    )}
                    {i === 3 && (
                      <div className="h-5 w-3/4 bg-gray-100 rounded mt-1"></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Guardian Information Section */}
          <div className="mt-8">
            <div className="h-5 w-48 bg-gray-200 rounded mb-4"></div>
            <div className="space-y-4">
              {[...Array(2)].map((_, index) => (
                <div
                  key={index}
                  className="bg-[#F5F8F9] rounded-xl p-4 border border-[#E4E8EA]"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-gray-200"></div>
                    <div className="space-y-1">
                      <div className="h-5 w-40 bg-gray-200 rounded"></div>
                      <div className="h-4 w-24 bg-gray-100 rounded"></div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {[...Array(4)].map((_, i) => (
                      <div key={i} className="space-y-1">
                        <div className="h-4 w-24 bg-gray-200 rounded"></div>
                        <div className="h-5 w-full bg-gray-100 rounded"></div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar - takes full width on mobile, 1 column on desktop */}
      <div className="space-y-6">
        <div className="bg-white rounded-xl p-6 border border-[#E4E8EA] animate-pulse">
          <div className="h-6 w-40 bg-gray-200 rounded mb-6"></div>

          <div className="space-y-6">
            {/* Card 1 */}
            <div className="p-4 rounded-lg bg-[#F5F8F9]">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-gray-200"></div>
                <div className="space-y-1">
                  <div className="h-5 w-32 bg-gray-200 rounded"></div>
                  <div className="h-4 w-20 bg-gray-100 rounded"></div>
                </div>
              </div>
              <div className="mt-3 h-2 w-full bg-gray-100 rounded-full"></div>
            </div>

            {/* Card 2 */}
            <div className="p-4 rounded-lg bg-[#F5F8F9]">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-gray-200"></div>
                <div className="space-y-1">
                  <div className="h-5 w-32 bg-gray-200 rounded"></div>
                  <div className="h-4 w-20 bg-gray-100 rounded"></div>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-1 mt-2">
                {[...Array(3)].map((_, i) => (
                  <div key={i} className="h-10 bg-gray-100 rounded-md"></div>
                ))}
              </div>
            </div>

            {/* Card 3 */}
            <div className="p-4 rounded-lg bg-[#F5F8F9]">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-gray-200"></div>
                <div className="space-y-1">
                  <div className="h-5 w-32 bg-gray-200 rounded"></div>
                  <div className="h-4 w-20 bg-gray-100 rounded"></div>
                </div>
              </div>
              <div className="h-6 w-24 bg-gray-100 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
